import React, { useState } from "react";
// REDUX
import { useSelector } from "react-redux";
// NAVIGATION
import { useLocation } from "react-router-dom";
// CUSTOM HOOKS
import useGetAllMessages from "../../../../customHooks/GET_requests/useGetAllMessages";
import useGetOneAdapter from "../../../../customHooks/GET_requests/useGetOneAdapter";
// COMPONENTS
import KeysTable from "./KeysTable";
import KeysAssignInterfaceAdapter from "../../keys/KeysAssignInterfaceAdapter";
// INTERFACES
import { RootState } from "../../../../app/store";

export default function KeyPage() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const location = useLocation();
  const adapterId = new URLSearchParams(location.search).get("idAdapter");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */
  const [idMessageTypeSelected, setIdMessageTypeSelected] = useState<number>(99999);

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { theme } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // CUSTOM HOOKS *********************************** */
  const { adapter, isLoadingGetOneAdapter } = useGetOneAdapter({
    id: adapterId ?? "",
  });
  const {
    messages,
    isErrorGetAllMessages,
    totalRowsGetAllMessages,
    errorMessageGetAllMessages,
    isLoadingGetAllMessages,
  } = useGetAllMessages({
    deviceType: String(adapter.liftType),
    messageTypeId: idMessageTypeSelected.toString(),
  });

  // ************************************************ */
  // HELPERS **************************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // USE MEMO *************************************** */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************ */
  // USE CALLBACK *********************************** */

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div className={`layout__contentPage__${theme}`}>
      <KeysAssignInterfaceAdapter />
      <KeysTable
        adapter={adapter}
        isLoading={isLoadingGetOneAdapter || isLoadingGetAllMessages}
        messages={messages}
        totalRowsGetAllMessages={totalRowsGetAllMessages}
        isErrorGetAllMessages={isErrorGetAllMessages}
        errorMessageGetAllMessages={errorMessageGetAllMessages}
        setIdMessageTypeSelected={(id: any) => {
          setIdMessageTypeSelected(id);
        }}
      />
    </div>
  );
}
